import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "titlebar",
  class: "gradient"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-md-12" }, [
      /*#__PURE__*/_createVNode("h2", null, "Search results")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
}